import { render, staticRenderFns } from "./YHCS-order-pay.vue?vue&type=template&id=268a5b9f"
import script from "./YHCS-order-pay.vue?vue&type=script&lang=js"
export * from "./YHCS-order-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports